<mat-card appearance="outlined" [formGroup]="formGroup" *ngIf="applicationType && applicationType !== 'continue'">
<!--  <mat-card appearance="outlined" [formGroup]="formGroup" *ngIf="applicationType && applicationType !== 'continue' && applicationType !== 'old-personal'">-->
  <mat-card-header>
    <mat-card-title>{{ opts.label || 'Borrower type' }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select borrower type and number of borrowers</mat-label>
          <mat-select [disabled]="applicationType === 'new-company'" placeholder="Select borrower type and number of borrowers" formControlName="borrowerType">
            <mat-option *ngFor="let type of borrowingTypes" [value]="type.id" [disabled]="type?.ext?.disabled">{{type.text}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'borrowerType'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline" *ngIf="selectedType?.ext?.requireCount">
          <mat-label>{{selectedType?.ext?.label || 'Borrower Count'}}</mat-label>
          <mat-select placeholder="{{selectedType?.ext?.label || 'Borrower Count'}}" formControlName="borrowerCount">
            <mat-option [value]="1" *ngIf="formGroup.get('borrowerType').value !== 'joint-individual'">1</mat-option>
            <mat-option [value]="2">2</mat-option>
            <mat-option [value]="3">3</mat-option>
            <mat-option [value]="4">4</mat-option>
            <mat-option [value]="5" *ngIf="applicationType === 'new-trust'">5</mat-option>
            <mat-option [value]="6" *ngIf="applicationType === 'new-trust'">6</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'borrowerCount'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4" *ngIf="smsfEnabled">
        <mat-form-field appearance="outline" *ngIf="applicationType === 'new-trust'">
          <mat-label>Trust type</mat-label>
          <mat-select placeholder="Trust Type" formControlName="trustType">
            <mat-option *ngFor="let type of trustTypes" [value]="type.id">{{type.text}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'trustType'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <ng-container *ngIf="(applicationType === 'new-trust') || (isFurtherAdvance && trustList.length) then trust"></ng-container>
    <ng-container *ngIf="(applicationType === 'new-company' || isFurtherAdvance) && formGroup.value.borrowerType === 'company' then company">
    </ng-container>
  </mat-card-content>
</mat-card>

<ng-template #trust>
  <div [formGroup]="formGroup" class="mb-2">
    <div class="row">
      <div class="col-sm-8">
        <fmc-abn-search
          [disabled]="formGroup.controls.trustNoABN.value"
          [mode]="'abn'"
          [parentFormGroup]="formGroup"
          [controlName]="'trustABN'"
          [placeholderText]="'Please enter ABN of Trust'"
          (abnResults)="selectAbnRecord($event, 'trust', opts.trustIndex, formGroup, 'trustABN')">
        </fmc-abn-search>
      </div>
      <div class="col-sm-4">
        <mat-checkbox formControlName="trustNoABN">I don't have an ABN</mat-checkbox>
        <mat-error>
          <app-validation-partial [formGroup]="formGroup" [fieldName]="'trustNoABN'"></app-validation-partial>
        </mat-error>
      </div>
    </div>
  </div>
  <ng-container *ngIf="formGroup.value.borrowerType === 'trust-with-company' then company"></ng-container>
</ng-template>

<ng-template #company>
  <div [formGroup]="formGroup">
    <div class="row">
      <div class="col-sm-8">
        <fmc-abn-search [mode]="'acn'" [parentFormGroup]="formGroup" [controlName]="'companyACN'"
          [placeholderText]="'Please enter ACN of the Company'" (abnResults)="selectCompanyAbnRecord($event)"></fmc-abn-search>
      </div>

      <div class="col-sm-3">
        <mat-form-field appearance="outline">
          <mat-label>ACN Registered</mat-label>
          <input matInput readonly placeholder="ACN Registered" formControlName="acnRegistered">
        </mat-form-field>
      </div>
    </div>

  </div>
</ng-template>
